export default __webpack_public_path__ + "static/media/Raphael.474c86d1.JPG";